module.exports = __webpack_public_path__ + "static/media/benefits-ic-03.c6738adb.svg";